import PropTypes from "prop-types";
import * as React from "react";
import { useDebounce, useShopsSearchDashboard } from "../../../hooks";
import { Autocomplete, Avatar, Typography } from "../../../themeV2";
import css from "./sections.module.css";

const SignerPicker = function SignerPicker({ excludedIds, onAdd }) {
  const [inputValue, setInputValue] = React.useState("");
  const [query, setQuery] = React.useState("");
  useDebounce(() => setQuery(inputValue.trim()), 250, [inputValue]);

  const { shops } = useShopsSearchDashboard(query, {
    excludeCollections: true,
    excludedIds,
  });

  return (
    <Autocomplete.Root
      label="Add a signer"
      placeholder="Search shops"
      value={null}
      inputValue={inputValue}
      onInputValueChange={setInputValue}
      onValueChange={(shop) => {
        if (!shop) return;
        onAdd({
          influencerId: shop.influencer_id,
          name: shop.name,
          avatarUrl: shop.avatar_url,
        });
        setInputValue("");
      }}
      /* The results arrive already matched by the server. */
      autoComplete="none"
      itemToStringLabel={(shop) => shop?.name ?? ""}
    >
      {shops.map((shop) => (
        <Autocomplete.Item key={shop.influencer_id} value={shop}>
          <span className={css.option}>
            <Avatar size="sm" src={shop.avatar_url} alt="" />
            <Typography variant="body-lg" as="span">
              {shop.name}
            </Typography>
          </span>
        </Autocomplete.Item>
      ))}
      <Autocomplete.Empty>
        {query ? "No matching shops." : "Type a shop name to search."}
      </Autocomplete.Empty>
    </Autocomplete.Root>
  );
};

SignerPicker.propTypes = {
  excludedIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default SignerPicker;
